import React, { FC, useCallback, useContext } from "react";
import { useTranslation } from "react-i18next";

import { EditableSection } from "@/components/EditableSection";
import { Header } from "@/components/Header";
import { Section } from "@/components/Section";
import { UserContext } from "@/components/User";
import { ISessionUser } from "@/data/session";
import { Flex } from "@/eworkitComponents";
import { useToasts } from "@/views/components/Toast/useToasts";
import { TimezoneSection } from "@/views/Settings/UserSettings/UserAccount/UserName/TimezoneSection";

import { LanguageSection } from "../UserName";

import "../_user-account-settings.scss";

export const SystemAppearanceSettings: FC = () => {
  const User = useContext(UserContext);
  const { addToast } = useToasts();

  const { t } = useTranslation("session");

  const handleUserUpdate = useCallback(
    async (user: ISessionUser) => {
      User.updateContextUser(user);

      addToast({ text: t("USERS.SETTINGS.USER_ACCOUNT.SUCCESS_MESSAGE"), type: "success" });
    },
    [addToast, User.updateContextUser, User.sessionUser],
  );

  const baseClass = "user-account-settings";

  return (
    <Section padding={["lg"]} borderRadius>
      <Flex className={baseClass} grow={1} direction="column" innerBorder={true} innerPadding="md">
        <Header size="sm" weight="bold" text={t("USERS.SETTINGS.USER_SETTINGS.TAB_NAME.APPEARANCE")} />
        <EditableSection>
          {editableProps => (
            <LanguageSection editableProps={editableProps} record={User.sessionUser} onUpdate={handleUserUpdate} />
          )}
        </EditableSection>
        <EditableSection>
          {editableProps => (
            <>
              <TimezoneSection editableProps={editableProps} record={User.sessionUser} onUpdate={handleUserUpdate} />
              <div className={`${baseClass}__space`} />
            </>
          )}
        </EditableSection>
      </Flex>
    </Section>
  );
};
